import React from 'react';
import PropTypes from 'prop-types';
import { useOrderView } from '@/contexts/OrderViewContext';
import SearchBox from '@/components/common/SearchBox';
import ActionBox from '@/components/OrderToolbar/ActionBox/ActionBox';
import classes from '@/components/OrderToolbar/OrderToolbar.module.scss';

const OrderToolbar = ({
  actionHandler,
  searchHandler,
  selectedItem,
  selectedItems,
  clearChosenTypeAndTags,
  history,
  query,
}) => {
  const { activeOrder } = useOrderView();

  return (
    <div className={classes.OrderToolbarWrapper}>
      <SearchBox
        handler={searchHandler}
        isClientsPageHeader={false}
        clearChosenTypeAndTags={clearChosenTypeAndTags}
        query={query}
      />
      <ActionBox
        history={history}
        actionHandler={actionHandler}
        selectedItem={selectedItem || activeOrder}
        selectedItems={selectedItems}
      />
    </div>
  );
};

OrderToolbar.propTypes = {
  history: PropTypes.object.isRequired,
  searchHandler: PropTypes.func.isRequired,
  actionHandler: PropTypes.func.isRequired,
  selectedItems: PropTypes.object.isRequired,
  selectedItem: PropTypes.object,
  clearChosenTypeAndTags: PropTypes.bool,
  query: PropTypes.object,
};

OrderToolbar.defaultProps = {
  clearChosenTypeAndTags: false,
  query: {},
};

export default OrderToolbar;
